<template>
  <KycBody/>
</template>

<script>
// @ is an alias to /src
import KycBody from '@/components/KycBody.vue'

export default {
  name: 'KycView',
  components: {
    KycBody
  }
}
</script>
